import { createContext, useContext, useState } from 'react';

const SignupContext = createContext({});

export function useSignup() {
  return useContext(SignupContext);
}

export function SignupProvider({ children }) {
  // Initialiser avec sessionStorage si disponible
  const [signupFormData, setSignupFormData] = useState(null);
  const [signupAccountData, setSignupAccountData] = useState(null);
  const [requiresAccountCreation, setRequiresAccountCreation] = useState(true);
  const [createdProfileId, setCreatedProfileId] = useState(() => {
    // Restaurer depuis sessionStorage au démarrage
    try {
      const stored = sessionStorage.getItem('createdProfileId');
      return stored || null;
    } catch {
      return null;
    }
  });

  const setFormData = (data) => {
    setSignupFormData(data);
  };

  const setAccountData = (data) => {
    setSignupAccountData(data);
  };

  const setProfileId = (id) => {
    setCreatedProfileId(id);
    
    // Sauvegarder dans sessionStorage pour persistance
    try {
      if (id) {
        sessionStorage.setItem('createdProfileId', id);
      } else {
        sessionStorage.removeItem('createdProfileId');
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[SignupContext] Failed to save to sessionStorage:', e);
    }
  };

  const clearSignupData = () => {
    setSignupFormData(null);
    setSignupAccountData(null);
    setRequiresAccountCreation(true);
    setCreatedProfileId(null);
    // Nettoyer sessionStorage
    try {
      sessionStorage.removeItem('createdProfileId');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[SignupContext] Failed to clear sessionStorage:', e);
    }
  };

  const value = {
    signupFormData,
    signupAccountData,
    requiresAccountCreation,
    createdProfileId,
    setFormData,
    setAccountData,
    setRequiresAccountCreation,
    setProfileId,
    clearSignupData,
  };

  return <SignupContext.Provider value={value}>{children}</SignupContext.Provider>;
}

